import { useBaseStore } from '@common/stores/storage';
import { msSessionStorage } from '@common/utils/cache';
import { loadScript } from '@common/utils/loadScript';

const afPlatform = () => {
  const __map = {
    'ALIPAY-SW': 'alipaylife',
    'SYH-SW': 'alipaylife',
    MSJQ_ALIPAY: 'alipaylife',
    MS_WeChat_AYH: 'wechatmp',
    MS_WECHAT_ZXH: 'wechatmp',
    MS_WECHAT_AYHJD: 'wechatmp',
    mswechat: 'wechatmp',
  };
  const { channel } = useBaseStore();
  return __map[channel] ?? 'h5';
};

const afPlatformId = () => {
  const __map = {
    'ALIPAY-SW': '2016031701220968',
    'SYH-SW': '2016102002260681',
    MSJQ_ALIPAY: '2016110102463932',
    MS_WeChat_AYH: 'wx3f790cd34cfb12ef',
    MS_WECHAT_ZXH: 'wx3f790cd34cfb12ef',
    MS_WECHAT_AYHJD: 'wx3f790cd34cfb12ef',
    mswechat: 'wxf0473d84481bab3a',
  };
  const { channel } = useBaseStore();
  return __map[channel] ?? '';
};

// 动态加载反欺诈脚本
// const staticUrl =
//   process.env.NODE_ENV === 'production'
//     ? '//static-risk-gtm.msxf.com/public-platform/static/jsanalytics/msxf-analytics.min.js'
//     : '//static.msxf.test/static/analytics/msxf-analytics.min.js';

const staticUrl =
  '//static-sim.xiaolongcloud.com/public-platform/static/jsanalytics/msxf-analytics.min.js';
// 反欺诈能力加载
export default {
  install: async (vue, options) => {
    try {
      // 反欺诈的SDK很神奇，自定义选项需要提前在window上挂载好，然后脚本内部再进行拉取。
      // 反欺诈msgId
      window.afMsgId = '';
      // 获取msgId方法
      window.afTracker = {};
      // 指纹设备，先在项目本地声明
      window.__mat = window.__mat || [];

      window.__mat.push([
        '__getClientInfo',
        function (info) {
          info = info || {};
          // 存储反欺诈信息
          if (JSON.stringify(info).length > 700) {
            msSessionStorage.remove('PUBLIC_AFCLIENTINFO');
          } else {
            msSessionStorage.set('PUBLIC_AFCLIENTINFO', info);
          }
        },
      ]);

      const { appKey, cooperatorId } = useBaseStore();
      // create tracker 【必须】传入trackUrl与applyCode
      window.__mat.push([
        '__create',
        process.env.NODE_ENV === 'production'
          ? 'https://crawlersdkapi.xiaolongcloud.com'
          : 'http://crawlersdkapi.msxf.msxfyun.test',
        'SYH-APP',
        {
          platform: afPlatform(), // 平台
          platformId: afPlatformId(), // 平台 ID
          openId: '', // 用户 ID，本次迁移不涉及这部分
          appKey: appKey,
          channelCode: cooperatorId,
          ...(options?.locationCache && { locationCache: true }),
        },
      ]);

      window.__mat.push([
        '__get',
        function (tracker) {
          msSessionStorage.set('PUBLIC_TRACKER', tracker);
          window.afTracker = tracker;
        },
      ]);
      window.__mat.push([
        '__transforUserInfo',
        {
          key: 'userId',
          value: useBaseStore().userId, //添加用户userId
        },
      ]);

      await loadScript(staticUrl); // todo 需要放开
    } catch (err) {
      console.log('反欺诈加载失败', err);
    }
  },
};

export function transforUserId() {
  window.__mat.push([
    '__transforUserInfo',
    {
      key: 'userId',
      value: useBaseStore().userId, //添加用户userId
    },
  ]);
}

// 独立调用地理位置弹窗逻辑，提前获取地理位置授权并缓存地理位置信息，5分钟之内的事件上报，使用地理位置缓存数据。
export function setTrackLocation() {
  window.__mat.push(['__setTrackLocation']);
}
